import { render, staticRenderFns } from "./AddGd.vue?vue&type=template&id=0125ad58&scoped=true"
import script from "./AddGd.vue?vue&type=script&lang=js"
export * from "./AddGd.vue?vue&type=script&lang=js"
import style0 from "./AddGd.vue?vue&type=style&index=0&id=0125ad58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0125ad58",
  null
  
)

export default component.exports